import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const TickCircle: FC<IconProps> = ({ ...props }) => {
  const isDark = props.color === '#000000' || props.color === 'brandTwo100';

  return (
    <Icon {...props}>
      <path
        fill="currentColor"
        d="M16 1.5C7.98545 1.5 1.5 7.99864 1.5 16c0 8.0014 6.48545 14.5 14.5 14.5 8.0145 0 14.5-6.4855 14.5-14.5 0-8.01455-6.4855-14.5-14.5-14.5Z"
      />
      <path
        fill={isDark ? '#FFFFFF' : '#000000'}
        fillRule="evenodd"
        d="m12.8759 19.7832 8.7001-8.7c.3295-.3295.8832-.3295 1.2127 0 .3295.3296.3295.8832 0 1.2127l-9.9128 9.9127-4.48177-4.4818c-.32954-.3295-.32954-.8832 0-1.2127.32955-.3295.88318-.3295 1.21273 0l3.26904 3.2691Z"
        clipRule="evenodd"
      />
    </Icon>
  );
};
